import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Success.module.css';
import { Helmet } from 'react-helmet';

function Success() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const message = searchParams.get('message');
    const trxID = searchParams.get('trxID');
    const refundTrxID = searchParams.get('refundTrxID');

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Payment Successful - RUSU BD</title>
            </Helmet>
            <div className={styles['success-page']}>
                <div className={styles['success-container']}>
                    {/* Success Icon */}
                    <div className={styles['success-icon-wrapper']}>
                        <div className={styles['success-icon-circle']}>
                            <svg
                                className={styles['success-icon']}
                                width="64"
                                height="64"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                    </div>

                    {/* Title */}
                    <h1 className={styles['success-title']}>Payment Successful!</h1>

                    {/* Message */}
                    <p className={styles['success-message']}>
                        {message || "Your payment has been processed successfully. Your package has been activated!"}
                    </p>

                    {/* Transaction Details */}
                    {(trxID || refundTrxID) && (
                        <div className={styles['transaction-details']}>
                            <div className={styles['details-header']}>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                                    <line x1="2" y1="10" x2="22" y2="10"></line>
                                </svg>
                                <h3>Transaction Details</h3>
                            </div>

                            {trxID && (
                                <div className={styles['detail-row']}>
                                    <span className={styles['detail-label']}>Transaction ID:</span>
                                    <span className={styles['detail-value']}>{trxID}</span>
                                </div>
                            )}

                            {refundTrxID && (
                                <div className={styles['detail-row']}>
                                    <span className={styles['detail-label']}>Refund Transaction ID:</span>
                                    <span className={styles['detail-value']}>{refundTrxID}</span>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Success Info Box */}
                    <div className={styles['success-info-box']}>
                        <svg
                            className={styles['info-icon']}
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                        <div>
                            <p className={styles['info-title']}>What's Next?</p>
                            <p className={styles['info-text']}>
                                Your package has been activated and is ready to use. You can now access all premium features.
                                Check your dashboard for updated subscription details.
                            </p>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className={styles['success-actions']}>
                        <button
                            className={styles['button-primary']}
                            onClick={() => navigate("/dashboard")}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <rect x="3" y="3" width="7" height="7"></rect>
                                <rect x="14" y="3" width="7" height="7"></rect>
                                <rect x="14" y="14" width="7" height="7"></rect>
                                <rect x="3" y="14" width="7" height="7"></rect>
                            </svg>
                            Go to Dashboard
                        </button>
                        <button
                            className={styles['button-secondary']}
                            onClick={() => navigate("/billing")}
                        >
                            View Subscription
                        </button>
                    </div>

                    {/* Support Link */}
                    <p className={styles['success-support']}>
                        Questions?{" "}
                        <a href="mailto:support@ecomtechbd.com" className={styles['support-link']}>
                            Contact Support
                        </a>
                    </p>
                </div>
            </div>
        </>
    );
}

export default Success;
